<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <span class="suspended-badge" data-cy="suspended_badge">{{ t('business.members.list.suspended') }}</span>
</template>

<style lang="scss" scoped>
.suspended-badge {
  padding: 2px 7px;
  border-radius: 0.25rem;
  background: $c-grey-fine;
  color: $c-grey-dark;
  font-size: 0.625rem;
  font-weight: 800;
  line-height: 1rem;
  text-transform: uppercase;
}
</style>
